module.exports = __webpack_public_path__ + "static/media/punch.0cb89b88.mp3";